module.exports = __webpack_public_path__ + "static/media/features_seguro.88d47bc1.jpg";